<template>
    <div class="footer-bar">
        <ul class="footer-list">
            <li>
                <a href="#" @click.prevent="activeContentChange('about_us','about_us','privacy')">Privacy</a>
            </li>
            <li>
                <a href="#" @click.prevent="activeContentChange('about_us','about_us','terms')" >Terms and Conditions</a>
            </li>
            <li>
                <a href="#" @click.prevent="activeContentChange('about_us','about_us','help')">Help</a>
            </li>
            <li>
                <a href="#" @click.prevent="activeContentChange('about_us','about_us','contact')">Contact Us</a>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "Footer",
        methods:{
            activeContentChange:function (content_id,content_type,sub_open) {
                this.$parent.activeContentChange(content_id, content_type,sub_open);
            }
        }
    }
</script>

<style scoped>
    .footer-bar {
        position: absolute;
        bottom: -35px;
        width: 100%;
        padding-left: 300px;
    }

    .footer-list {
        text-align: center;
        width: 100%;
    }

    .footer-list li {
        display: inline-block;
        color: #919191;
        font-size: 14px;
        margin: 0 10px;
        list-style-type: none;
    }

    .footer-list a {
        color: inherit;
        text-decoration: none;
    }
</style>